'use es6';

import * as FilterKey from '../constants/search/FilterKey';
import events from '../../events.yaml';
import { getCatalogServiceTrackingName } from './i18n';
let tracker;
export const getTracker = () => tracker;
export const setTracker = _tracker => {
  tracker = _tracker;
};
export const getTrackerConfig = (inAppOrPublic = 'in-app') => ({
  events,
  properties: {
    namespace: 'marketplace',
    type: 'solution provider',
    inAppOrPublic
  }
});
export const track = (eventName, properties) => {
  getTracker().track(eventName, properties);
};
export const getStorefrontFiltersEventProperties = (filters, catalogServices) => {
  const {
    [FilterKey.SERVICE]: service,
    [FilterKey.INDUSTRY]: industry,
    [FilterKey.COUNTRY]: country,
    [FilterKey.STATE]: state,
    [FilterKey.LANGUAGE]: language,
    [FilterKey.BUDGET]: budget,
    [FilterKey.CERTIFICATION]: certification,
    [FilterKey.TIER]: tier,
    [FilterKey.OFFICE_LOCATION]: location,
    [FilterKey.SORTS]: sorts,
    [FilterKey.SEARCH]: search
  } = filters;
  const properties = {
    service: service.map(serviceId => getCatalogServiceTrackingName(serviceId, catalogServices)),
    industry,
    country,
    state,
    language,
    budget,
    certification,
    tier,
    location,
    sorts,
    search,
    searchLength: search ? search.length : undefined
  };
  Object.keys(properties).forEach(key => {
    if (!properties[key]) {
      delete properties[key];
    }
  });
  return properties;
};